import { css } from '@emotion/core'
import styled from '@themes/theme'
import { NavBottomPadding } from '@styles/base.style'

const CouponGmoneyStyle = css`
  position: absolute;
  top: 50%;
  right: 0px;
  transform: translateY(-50%);
  width: 13px;
`
export const CouponWrap = styled.div`
  position: relative;
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 100%;
  min-height: calc(100vh - 86px);
  padding: 0 31px ${NavBottomPadding};
  background: ${props => props.theme.color.modalBg};
  img {
    transform: translate3d(0, 0, 0);
  }
  .coupon-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .coupon-notice {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 23px;
    .coupon-notice-list {
      position: relative;
      display: flex;
      flex-flow: column;
      align-items: flex-start;
      width: 178px;
      &--item {
        color: ${props => props.theme.color.modalTxt};
        font-size: ${props => props.theme.font.small};
        margin-bottom: 6px;
        &:last-of-type {
          margin-bottom: 0;
        }
        .number {
          display: inline-flex;
          justify-content: center;
          align-items: center;
          width: 16px;
          height: 16px;
          margin-right: 8px;
          color: ${props => props.theme.color.themeTxt};
          font-size: ${props => props.theme.font.small};
          background: ${props => props.theme.color.modalBlue};
          border-radius: 50%;
        }
      }
    }
  }
  .coupon-list {
    position: relative;
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 18px 14px;
    &--box {
      position: relative;
      flex: 1;
      &--input {
        width: 100%;
        max-height: 333px;
        overflow-x: hidden;
        overflow-y: auto;
        padding: 14px 0 14px 14px;
        line-height: 2.4rem;
        color: ${props => props.theme.color.modalTxt};
        font-size: ${props => props.theme.font.small};
        text-align: left;
        background: ${props => props.theme.color.themeTxt};
        border: none;
        resize: none;
        border-radius: 5px;
        &::placeholder {
          color: ${props => props.theme.color.btn} !important;
          opacity: 1; /* Firefox */
        }
        &:-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: ${props => props.theme.color.btn} !important;
        }
        &::-ms-input-placeholder { /* Microsoft Edge */
        color: ${props => props.theme.color.btn} !important;
        }
      }

      /* input-check */
      &--check-list {
        width: 100%;
        max-height: 290px;
        overflow-x: hidden;
        overflow-y: auto;
        border-radius: 5px;
        background: ${props => props.theme.color.themeTxt};
        &--item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 34px;
          line-height: 3.4rem;
          padding: 0 14px;
          &--num {
            width: 17px;
            color: ${props => props.theme.color.modalgray};
            font-size: ${props => props.theme.font.small};
          }
          &--info {
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 33.5px;
            &--num {
              color: ${props => props.theme.color.modalTxt};
              font-size: ${props => props.theme.font.small};
            }
            &--money {
              position: relative;
              padding-right: 16px;
              color: ${props => props.theme.color.modalTxt};
              font-size: ${props => props.theme.font.small};
              svg {
                ${CouponGmoneyStyle};
              }
            }
            &--error-message {
              display: none;
              font-size: ${props => props.theme.font.small};
            }
          }
          &.error {
            background: ${props => props.theme.color.modalSubBg2};
            .coupon-list--box--check-list--item--num, .coupon-list--box--check-list--item--info--num {
              color: ${props => props.theme.color.red};
            }
            .coupon-list--box--check-list--item--info--money {
              display: none;
            }
            .coupon-list--box--check-list--item--info--error-message {
              display: block;
              color: ${props => props.theme.color.red};
            }
          }
        } /* coupon-list--box--check-list--item */
      }
    } /* coupon-list--box */
    .right-contents {
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: space-between;
      width: 72px;
      .reset-btn {
        width: 43px;
        height: 43px;
        img {
          width: 100%;
          height: auto;
        }
      }
      .coupon-img {
        width: 36px;
        height: auto;
      }
    }
    .coupon-btn {
      width: 100%;
      height: 69px;
      border-radius: 0;
      position: absolute;
      bottom: -69px;
      left: 50%;
      transform: translateX(-50%);
      .coupon-bg {
        z-index: -1;
      }
    }

    &.coupon-check {
      display: flex;
      flex-flow: column;
      flex-wrap: wrap;
      justify-content: flex-end;
      min-height: 280px;
      .coupon-info {
        position: relative;
        display: flex;
        align-items: flex-end;
        background: ${props => props.theme.color.modalBlue};
        border-radius: 5px;
        margin-bottom: 10px;
        &--item {
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex: 1;
          height: 33px;
          padding: 0 14px;
          &:nth-of-type(2) {
            &::before {
              content: '';
              display: block;
              position: absolute;
              top: 50%;
              left: 0;
              transform: translateY(-50%);
              width: 1px;
              height: 15px;
              border-left: 1px solid ${props => props.theme.color.themeTxt};
              opacity: .25;
            }
          }
          .amount {
            display: inline-flex;
            align-items: center;
            color: ${props => props.theme.color.themeTxt};
            font-size: ${props => props.theme.font.small};
            svg {
              width: auto;
              height: 13px;
              margin-right: 6px;
            }
          }
          .count {
            opacity: .65;
            color: ${props => props.theme.color.themeTxt};
            font-size: ${props => props.theme.font.small};
          }
        }
      }
    }
  }

  &.pc-coupon-wrap {
    min-height: 100%;
    padding-top: 46px;
    .coupon-list {
      &--box {
        &--input {
          max-height: 35vh;
        }
        &--check-list {
          max-height: 30vh;
        }
      }
    }
  }

`
